import { FETCH_USERS, USERS_FILTER_SET, USERS_PAGE_SET, IMPERSONATE_USER } from '../../constants/Constants';

export const fetchUsers = () => ({ type: FETCH_USERS.REQUESTED });
export const setUsersFilter = filter => ({ type: USERS_FILTER_SET, payload: filter });
export const setUsersPage = page => ({ type: USERS_PAGE_SET, payload: { page } });
export const impersonateUser = (userId, apiClient) => ({
  type: IMPERSONATE_USER.REQUESTED,
  payload: { userId, apiClient }
});



// WEBPACK FOOTER //
// ./src/actions/entities/UserActions.js